<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Change AE File</modal-header>
        </div>
            <div style="margin: 5px 5px 5px 0px">Upload aep or aepx file again incase of any structural changes</div>
            <upload-file icon="upload" ctaText="Upload New AE File" @input="onUploadFile" />
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" :hideConfirmText="true"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import UploadFile from '@/components/UploadFile/upload-file'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_delete_creative',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    UploadFile
  },
  props: {
    show: Boolean,
    confirmId: String
  },
  data: () => ({}),
  mounted () {},
  computed: {},
  methods: {
    onUploadFile (e) {
      this.close()
      this.startLoading()
      const files = e.target.files || e.dataTransfer.files
      const formData = new FormData()
      formData.append('file', files[0])
      formData.append('hash_id', this.confirmId)
      this.updateAeFile(formData).then((res) => {
        this.addNotification(res.success ? 'success' : 'danger', res.reason)
        this.finishLoading()
      })
    },
    confirm () {
      this.startLoading()
      this.deleteCreative(this.confirmId).then(() => {
        this.getCreatives(this.$route.params.id).then(() => {
          this.addNotification('success', `Creative successfully deleted.`)
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }

  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-change-ae-file.vue